<template>
  <section>
    <transition name="overlay-fade">
      <div class="overlay-message" v-show="savedOk">
        <p class="system-text">Uw profiel is opgeslagen</p>
      </div>
    </transition>
    <close-button @click="$emit('close')" class="close-button"></close-button>

    <div class="dialog-header">
      <h1>Mijn profiel</h1>
    </div>
    <div class="dialog-content">
      <form
        name="settingsForm"
        method="post"
        action="/settings"
        @submit.prevent="saveSettings()"
      >
        <div>
          <div class="field-wrapper username-holder">
            <div class="field-20 system-text">E-mail:</div>
            <div class="field-80 user-text">
              <input
                type="text"
                v-model="settings.username"
                name="username"
                readonly
              />
            </div>
          </div>

          <div class="field-wrapper">
            <div class="field-100">
              <input
                class="grey-field"
                type="text"
                placeholder="Naam"
                name="name"
                v-model="settings.name"
                maxlength="40"
                :class="{ invalid: v$.settings.name.$invalid }"
              />
            </div>
          </div>
          <div class="field-wrapper">
            <div class="field-100">
              <input
                class="grey-field"
                type="text"
                placeholder="Telefoonnummer"
                name="phone"
                maxlength="20"
                v-model="settings.phone"
                :class="{ invalid: v$.settings.phone.$invalid }"
              />
            </div>
          </div>
          <div class="password-wrapper" v-if="!theme.hideChangePw">
            <h4>Wachtwoord wijzigen</h4>

            <div class="field-wrapper">
              <div class="field-100">
                <password-input
                  v-model="settings.password"
                  :password="settings.password"
                  :invalid="v$.settings.password.$invalid"
                  placeholder="Huidig wachtwoord"
                ></password-input>
              </div>
            </div>
            <div class="field-wrapper">
              <div class="field-100">
                <password-input
                  v-model="settings.newPass"
                  :password="settings.newPass"
                  :invalid="v$.settings.newPass.$invalid"
                  :show-hint="true"
                  placeholder="Nieuw wachtwoord"
                  ref="newPassInput"
                ></password-input>
              </div>
            </div>
          </div>

          <div class="mfa-wrapper" v-if="!theme.hideMfaOption">
            <h4>Tweestapsverificatie</h4>
            <div class="field-wrapper">
              <div class="field-100">
                <p class="system-text">
                  <select-box
                    @action="setMfa()"
                    :selected="settings.requireMfa"
                    :color="theme.subColor"
                  ></select-box
                  ><span class="pointer" @click="setMfa()"
                    >Ontvang bij het inloggen een verificatiecode per
                    e-mail</span
                  >
                </p>
              </div>
            </div>
          </div>

          <h4>Voorkeuren</h4>
          <div class="field-wrapper">
            <div class="field-100" v-if="!theme.customFields.project.required">
              <p class="system-text">
                <select-box
                  :selected="settings.projectRequired"
                  @action="setProjectRequired()"
                  :color="theme.subColor"
                ></select-box
                ><span class="pointer" @click="setProjectRequired()"
                  >Altijd project opgeven bij orders</span
                >
              </p>
            </div>
            <div class="field-100" v-if="!theme.hideZipOption">
              <p class="system-text">
                <select-box
                  :selected="settings.unzipOnUpload"
                  @action="setUnzipFiles()"
                  :color="theme.subColor"
                ></select-box
                ><span class="pointer" @click="setUnzipFiles()"
                  >Zip bestanden uitpakken bij uploaden</span
                >
              </p>
            </div>

            <div class="field-100">
              <p class="system-text">
                <select-box
                  @action="setNotification('orderConfirmation')"
                  :selected="
                    settings.notificationPreferences?.orderConfirmation
                  "
                  :color="theme.subColor"
                ></select-box
                ><span
                  class="pointer"
                  @click="setNotification('orderConfirmation')"
                  >Ontvang een orderbevestiging per e-mail</span
                >
              </p>
            </div>

            <div class="field-100">
              <p class="system-text">
                <select-box
                  @action="setNotification('delivery')"
                  :selected="settings.notificationPreferences?.delivery"
                  :color="theme.subColor"
                ></select-box
                ><span class="pointer" @click="setNotification('delivery')"
                  >Ontvang een afleverbevestiging per e-mail</span
                >
              </p>
            </div>
          </div>
        </div>
        <span
          v-show="errorMsg"
          class="error-text"
          :style="{ color: theme.errorColor }"
          v-html="errorMsg"
        >
        </span>

        <div class="button-holder">
          <button
            class="pill-button default"
            :style="rootStore.buttons.pillDefault"
            type="submit"
            :disabled="v$.settings.$invalid"
          >
            Opslaan
          </button>
        </div>
      </form>
      <section class="delete-account">
        <h4>Verzoek tot beëindigen account</h4>
        <p>
          Via onderstaande knop kunt u een aanvraag doen voor het beëindigen van
          uw account en het wissen van bijbehorende gegevens.
        </p>
        <button class="main-button" @click="deleteRequest">
          MIJN ACCOUNT STOPZETTEN
        </button>
      </section>
    </div>
  </section>
</template>
<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { userSettings } from '@/api/api'
import DeleteRequest from '@/dialogs/DeleteRequest.vue'
import cloneDeep from 'lodash-es/cloneDeep'
import PasswordInput from '@/components/ui/PasswordInput.vue'
import { vuelidatePasswordPattern } from '@/api/passwords'
import { noLetters } from '@/api/validators'

export default {
  components: { PasswordInput },
  props: ['user'],
  data() {
    return {
      errorMsg: '',
      savedOk: false,
      settings: {
        notificationPreferences: {}
      },
      fullName: ''
    }
  },
  setup() {
    return { v$: useVuelidate() }
  },
  validations() {
    return {
      settings: {
        name: { required },
        phone: { required, noLetters },
        password: {},
        newPass: {
          vuelidatePasswordPattern
        }
      }
    }
  },
  computed: {
    theme() {
      return this.rootStore.theme
    }
  },
  mounted() {
    // notificationPreferences kan ontbreken in de API-response; behoud de default
    // zodat de template er niet op omvalt
    this.settings = {
      notificationPreferences: {},
      ...cloneDeep(this.user)
    }
    this.settings.password = ''
  },
  methods: {
    setProjectRequired() {
      this.settings.projectRequired = !this.settings.projectRequired
    },
    setUnzipFiles() {
      this.settings.unzipOnUpload = !this.settings.unzipOnUpload
    },
    setMfa() {
      this.settings.requireMfa = !this.settings.requireMfa
    },
    setNotification(type) {
      if (!this.settings.notificationPreferences) {
        this.settings.notificationPreferences = {}
      }
      this.settings.notificationPreferences[type] = !this.settings
        .notificationPreferences[type]
    },
    saveSettings() {
      userSettings(
        this.settings,
        this.settings.password,
        this.settings.newPass
      ).then((resp) => {
        if (resp.error) {
          this.errorMsg = resp.message
        } else {
          if (this.settings.printStore) {
            resp.printStore = this.settings.printStore
          }
          this.rootStore.setUser(resp)
          this.savedOk = true

          setTimeout(() => {
            this.$emit('close')
          }, 1000)
        }
      })
    },
    deleteRequest() {
      this.$modal.show(DeleteRequest, null, {
        height: 'auto',
        width: 380
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.password-wrapper {
  margin: 20px 0;
  position: relative;
}

.pass-info {
  position: absolute;
  top: -1px;
  right: 0;
}

.username-holder input {
  border-color: transparent;
}

.delete-account {
  padding-top: 10px;
  border-top: 1px solid #878787;
  margin-top: 20px;
}
</style>
